import {ObserversModule} from '@angular/cdk/observers';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PhxIconModule } from '../icon/icon.module';
import { PhxTabsetComponent } from './phx-tabset.component';
import { PhxBadgeModule } from './../badge/phx-badge.module';
import { PhxTabComponent } from './phx-tab.component';

@NgModule({
  declarations: [
    PhxTabsetComponent,
    PhxTabComponent,
  ],
  imports: [
    CommonModule,
    PhxIconModule,
    PhxBadgeModule,
    RouterModule,
    ObserversModule,
  ],
  exports: [
    PhxTabsetComponent,
    PhxTabComponent,
  ],
})
export class PhxTabsetModule { }
